import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
// import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
// import StayConnected from '../../Components/StayConnectedSection';

// import RightArrow from '../../assets/images/right-arrow.png';

export default function MortgageServices() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='service-page'>
      <Helmet>
        <title>Starlife: Mortgage Services</title>
        <meta
          name='description'
          content='Long after the ribbon is cut, we keep your investment performing beautifully.'
        />
        <meta
          name='keywords'
          content='Starlife, Asset & Property Services, investment, property management, real estate, investment performance'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>
          Mortgage Services | Smart financing tailored to your goals
        </h2>
        <p className='service-page-text'>
          We provide comprehensive mortgage solutions backed by expert guidance
          to ensure clients secure optimal financing for residential and
          commercial properties.
        </p>
      </div>
      <div className='our-services-section'>
        <h2 className='section-title'>Services</h2>
        <div className='service-list'>
          <Link
            // to={ROUTE_NAMES.ELITEPROPERTYMANAGMENT}
            className='service-block'
          >
            <h3>Residential and commercial mortgage services</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
          <Link
            // to={ROUTE_NAMES.ELITEPROPERTYMANAGMENT}
            className='service-block green-block'
          >
            <h3>Mortgage advisory and placement</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
        </div>
      </div>
      {/* <GetInTouchSection /> */}
      {/* <StayConnected /> */}
    </div>
  );
}
